<template>
  <div class="purchase">
    <el-table :data="tableData" :header-cell-style="{color: '#333',height:'2.083rem',backgroundColor: 'rgba(177,34,43, .08)'}" stripe style="width: 100%">
      <!-- <el-table-column prop="pic" width="64">
        <template slot-scope="scope">
          <el-popover placement="top-start" title="" trigger="hover">
            <img :src="scope.row.pic" alt="" style="width: 150px;height: 150px">
            <img slot="reference" :src="scope.row.pic" style="width: 44px;height: 62px">
          </el-popover>
        </template>
      </el-table-column> -->
      <el-table-column label="书籍id" prop="bookId" width='220'>
        <template slot-scope="scope">
          {{scope.row.resourceId}}
        </template>
      </el-table-column>
      <el-table-column label="订单号" prop="tradeNo">
        <template slot-scope="scope">
          {{scope.row.tradeNo}}
        </template>
      </el-table-column>
      <el-table-column label="订单金额(单位分)" prop="fee">
      </el-table-column>
      <el-table-column label="购买时间" prop="createTime">
        <template slot-scope="scope">
          {{$store.getters.unixTime(scope.row.createTime/1000)}}
        </template>
      </el-table-column>
      <!-- <el-table-column fixed="right" label="操作" >
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" style="color: #b1222b;">查看详情</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <Page :page="page" :size="limit" :total="count" @onPage="onPage"></Page>
  </div>
</template>

<script>
  import {getPurchaseRecordsOfCurrentUser} from '../.../../../../utils/router/reader.api'
  import Page from "@/components/common/Page.vue"

  export default {
    components: {Page},
    data() {
      return {
        tableData: [
          // {
          //   bookId: "xzgj1235011632706998752",
          //   createTime: '523857921',
          //   tradeNo: '1976541232',
          //   fee:'1000'
          // },
          // {
          //   bookId: "xz123501163",
          //   createTime: '529857921',
          //   tradeNo: '2976541232',
          //   fee:'400'
          // }
        ],
        page: 1,
        limit: 6,
        count: 0,
      }
    },
    methods: {
      toStr(val) {
        return val.length > 0 ? val.toString() : "无";
      },
      getRecord() {
        getPurchaseRecordsOfCurrentUser({}).then(res => {
          if (res && res.data.code === 200) {
            this.tableData = res.data.data
          }
        })
      },
      handleClick(item) {
        //   this.$router.push({
        //     path: "/details",
        //     query: {
        //       id: item.bookId,
        //     },
        //   });
      },
      onPage(page) {
        this.page = page
        this.getCollection()
      },
    },
    mounted() {
      this.getRecord()
    }
  }
</script>

<style lang="less" scoped>
  .purchase {
    background: #fff;
    padding: 2.083rem 1.563rem;
    min-height: 25rem;

    .head_pic {
      width: 2.292rem;
      height: 3.229rem;
    }

    /deep/ .el-table__header {
      font-size: 0.833rem;
      font-weight: none;
    }

    /deep/ .el-table__row {
      font-size: 0.833rem;
    }
  }
</style>
